import { render, staticRenderFns } from "./DocumentMarkdownEditor.vue?vue&type=template&id=8f681f50"
import script from "./DocumentMarkdownEditor.vue?vue&type=script&lang=js"
export * from "./DocumentMarkdownEditor.vue?vue&type=script&lang=js"
import style0 from "./DocumentMarkdownEditor.vue?vue&type=style&index=0&id=8f681f50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports